exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.content-wrap[data-v-6b23d736] {\n  padding: 20px;\n}\n.link-text[data-v-6b23d736] {\n  display: inline-block;\n  margin: 5px;\n  cursor: pointer;\n  color: #4297ff;\n}\n.form-img[data-v-6b23d736] {\n  width: 180px;\n  float: left;\n  margin-right: 10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6b23d736","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/blacklist.vue
// module id = 1154
// module chunks = 0